import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER,CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { routes } from './app.router';
import { ChartsModule } from 'ng2-charts';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { ModalModule } from 'ngx-bootstrap/modal';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { NouisliderModule } from 'ng2-nouislider';
import { RecaptchaModule } from 'ng-recaptcha';
import { NgxLoadingModule } from 'ngx-loading';
import { DragulaModule } from 'ng2-dragula';
import { MatSelectModule} from '@angular/material/select';
import { MatSidenavModule} from '@angular/material/sidenav';
import { MatMenuModule} from '@angular/material/menu';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { AngularSlickgridModule } from 'angular-slickgrid';

import { AppConfig } from './app.config';
import { AppComponent } from './app.component';
import { CosyCustomFormComponent } from './cosy-custom-form/cosy-custom-form.component';
import { CosyAsdComponent } from './cosy-asd/cosy-asd.component';
import { CosyLoginComponent } from './cosy-login/cosy-login.component';
import { CosyFormControlComponent } from './cosy-form-control/cosy-form-control.component';
import { CosyHtmlComponent } from './cosy-html/cosy-html.component';
import { CosyServerComponent } from './cosy-server/cosy-server.component';
import { CosyCollectionComponent } from './cosy-collection/cosy-collection.component';

import { CosyAppStateDataControllerService } from './service/controller/cosy-app-state-data-controller.service';
import { CosyCommunicationControllerService } from './service/controller/cosy-communication-controller.service';
import { CosyDynaeditorControllerService } from './service/controller/cosy-dynaeditor-controller.service';
import { CosyCustomizedValidationService } from './service/validator/cosy-customized-validation.service';
import { CosyFormGroupValidationService } from './service/validator/cosy-form-group-validation.service';
import { CosyHtmlElementGenerationService } from './service/generator/generator-html/cosy-html-element-generation.service';
import { CosyInitializationService } from './service/initializer/cosy-initialization.service';


import { HtmlChartComponent } from './cosy-custom-html-components/html-chart/html-chart.component';
import { HtmlMapComponent } from './cosy-custom-html-components/html-map/html-map.component';
import { HtmlSliderComponent } from './cosy-custom-html-components/html-slider/html-slider.component';
import { HtmlTreeComponent } from './cosy-custom-html-components/html-tree/html-tree.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCoffee, faSearch, faTrash, faBan, faPlusCircle, faSyncAlt, faEraser, faWindowClose, faCopy, faSave, faFile, faFileExcel, faEdit, faPencilAlt, faTimesCircle, faSortUp, faSortDown, faPlus, faMinus, faInfoCircle, faFilePdf, faFileUpload, faFileDownload, faSmile, faArrowCircleLeft, faArrowCircleRight } from '@fortawesome/free-solid-svg-icons';
import { CosyAutocompleteComponent } from './cosy-autocomplete/cosy-autocomplete.component';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CosyUploadFileComponent } from './cosy-upload-file/cosy-upload-file.component';
import { CollectionSearchComponent } from './cosy-collection/collection-search.component';
import { CosyFlexboxComponent } from './cosy-html/cosy-flexbox/cosy-flexbox.component';
import { CosyTriggerComponent } from './cosy-html/cosy-trigger/cosy-trigger.component';
import { CosyInputtextComponent } from './cosy-html/cosy-inputtext/cosy-inputtext.component';
import { CosyPicklistComponent } from './cosy-html/cosy-picklist/cosy-picklist.component';
import { CosyCheckboxComponent } from './cosy-html/cosy-checkbox/cosy-checkbox.component';
import { CosyValidatormessageComponent } from './cosy-html/cosy-validatormessage/cosy-validatormessage.component';
import { CosyMenuComponent } from './cosy-html/cosy-menu/cosy-menu.component';
import { CosyGridComponent } from './cosy-html/cosy-grid/cosy-grid.component';
import { CosyLabelComponent } from './cosy-html/cosy-label/cosy-label.component';
import { CosyEntityComponent } from './cosy-html/cosy-entity/cosy-entity.component';
import { CosyWizardComponent } from './cosy-html/cosy-wizard/cosy-wizard.component';
import { DatePipe } from '@angular/common';
import { TreeModule } from '@circlon/angular-tree-component';
import { CosyTreeComponent } from './cosy-dux/cosy-tree/cosy-tree.component';
import { CollectionCreatetreeComponent } from './cosy-collection/collection-createtree.component';
import {LOCALE_ID} from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import { CosyDynaeditorComponent } from './cosy-dynaeditor/cosy-dynaeditor.component';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { CosyDynaeditorGridComponent } from './cosy-dynaeditor/cosy-dynaeditor-grid/cosy-dynaeditor-grid.component';
import { CosyDynaeditorEntityComponent } from './cosy-dynaeditor/cosy-dynaeditor-entity/cosy-dynaeditor-entity.component';
import { CosyDynaeditorFormcontrolComponent } from './cosy-dynaeditor/cosy-dynaeditor-formcontrol/cosy-dynaeditor-formcontrol.component';
import { CosyDynaeditorWizardComponent } from './cosy-dynaeditor/cosy-dynaeditor-wizard/cosy-dynaeditor-wizard.component';
import { CosyAppmapComponent } from './cosy-appmap/cosy-appmap.component';
import { CosyAccessrightComponent } from './cosy-accessright/cosy-accessright.component';
import { CosyGridRowdetailViewComponent } from './cosy-html/cosy-grid/cosy-grid-properties/cosy-grid-row/cosy-grid-rowdetail-view/cosy-grid-rowdetail-view.component';

import { CosyGridRowdetailPreloadComponent } from './cosy-html/cosy-grid/cosy-grid-properties/cosy-grid-row/cosy-grid-rowdetail-preload/cosy-grid-rowdetail-preload.component';

import { SharedModule } from './shared/shared.module';
import { CosyBreadcrumbComponent } from './cosy-html/cosy-breadcrumb/cosy-breadcrumb.component';
import { CosyRibbonComponent } from './cosy-html/cosy-ribbon/cosy-ribbon.component';
registerLocaleData(localeDe, 'de');

export function initConfig(config: AppConfig) {
  return () => config.load();

}

@NgModule({
  declarations: [
    AppComponent,
    CosyCustomFormComponent,
    CosyFormControlComponent,
    CosyAsdComponent,
    CosyLoginComponent,
    CosyHtmlComponent,
    HtmlChartComponent,
    HtmlMapComponent,
    HtmlSliderComponent,
    HtmlTreeComponent,
    CosyServerComponent,
    CosyCollectionComponent,
    CosyAutocompleteComponent,
    CosyUploadFileComponent,
    CollectionSearchComponent,
    CosyFlexboxComponent,
    CosyTriggerComponent,
    CosyInputtextComponent,
    CosyPicklistComponent,
    CosyCheckboxComponent,
    CosyValidatormessageComponent,
    CosyMenuComponent,
    CosyGridComponent,
    CosyLabelComponent,
    CosyEntityComponent,
    CosyWizardComponent,
    CosyTreeComponent,
    CollectionCreatetreeComponent,
    CosyDynaeditorComponent,
    CosyDynaeditorGridComponent,
    CosyDynaeditorEntityComponent,
    CosyDynaeditorFormcontrolComponent,
    CosyDynaeditorWizardComponent,
    CosyAppmapComponent,
    CosyAccessrightComponent,
    CosyGridRowdetailViewComponent,
    CosyGridRowdetailPreloadComponent,
    CosyBreadcrumbComponent,
    CosyRibbonComponent

  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgbModule,
    TooltipModule,
    SharedModule,
    routes,
    //PaginationModule.forRoot(),
    ModalModule.forRoot(),
    ChartsModule,
    TabsModule.forRoot(),
    RecaptchaModule,
    NouisliderModule,
    NgxLoadingModule,
    ProgressbarModule,
    CollapseModule,
    //TreeModule.forRoot(),
    TreeModule,
    DragulaModule.forRoot(),
    FontAwesomeModule,
    MatAutocompleteModule,
    MatChipsModule,
    MatIconModule,
    MatInputModule,
    MatFormFieldModule,
    NgxExtendedPdfViewerModule,
    MatSelectModule,
    AngularSlickgridModule.forRoot(),
    MatSidenavModule,
    MatMenuModule
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'de' },
    CosyCommunicationControllerService,
    CosyAppStateDataControllerService,
    CosyDynaeditorControllerService,
    CosyCustomizedValidationService,
    CosyFormGroupValidationService,
    CosyHtmlElementGenerationService,
    CosyInitializationService,
    AppConfig,
    DatePipe,
    { provide: APP_INITIALIZER, useFactory: initConfig, deps: [AppConfig], multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor() {
    // Add an icon to the library for convenient access in other components
    library.add(faCoffee, faSearch, faTrash, faBan, faPlusCircle, faSyncAlt, faEraser, faWindowClose, faCopy, faSave, faFile, faFileExcel, faEdit, faPencilAlt, faTimesCircle, faSortUp, faSortDown, faPlus, faMinus, faInfoCircle, faFilePdf, faFileUpload, faFileDownload, faSmile, faArrowCircleLeft, faArrowCircleRight);
  }
}
